{
  "GenericAdminList_Footer_Add": "Hinzufügen",
  "GenericAdminList_Footer_View": "Sicht",
  "GenericAdminList_Footer_Change": "Ändern",
  "GenericAdminList_Footer_Delete": "Löschen",
  "GenericAdminList_Footer_Selected": "{} Ausgewählt",
  "GenericAdminList_Footer_NoRows": "Hier gibt es nichts zu sehen...",
  "NAME": "GenericAdminListLanguage"
}